import { ClipboardCheck, MessageSquare, Star } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateSupportTicketsQualityAssuranceAr: TemplateAr = {
  name: 'أتمتة مراجعة جودة تذاكر الدعم بالذكاء الاصطناعي',
  description:
    'راجع كل محادثة دعم تلقائياً من ناحية الجودة والامتثال وفرص التدريب. يعمل مع كل أنظمة التذاكر الرئيسية.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'تذكرة' },
    { icon: ClipboardCheck, label: 'مراجعة ذكية' },
    { icon: Star, label: 'تقييم', final: true },
  ],
  detailDescription: {
    paragraph1:
      'راجع كل محادثة دعم، مو عينة عشوائية في آخر الأسبوع. أول ما تنحل التذكرة، الـ AI يحلل الخيط كامل مقابل معايير الجودة عندك — وقت الرد، والنبرة، والدقة، والالتزام بالسياسات، وفعالية الحل. ثم يطلع تقييم جودة مفصّل يبيّن وش يحتاج تحسين ووش يستحق الإشادة.',
    paragraph2:
      'التقييمات والرؤى توصل تلقائياً لوين تحتاجها — تنبيه Slack لحالة تدريب عاجلة، أو تقرير Excel للمراجعة الأسبوعية، أو مستودع البيانات عندك لتحليل أعمق. وسير العمل مرن بما يكفي يشتغل مع أي نظام تشغّله أصلاً. والـ AI يعدّل معايير التقييم حسب معايير الجودة ومتطلبات الامتثال عندك.',
  },
  benefits: [
    'يراجع ١٠٠٪ من المحادثات، مو عينة عشوائية',
    'الـ AI يرصد فرص التدريب لحظياً',
    'ضمان الامتثال لأنظمة القطاع',
    'تتبّع اتجاهات الجودة على فريقك كله',
    'عبء مراجعة الجودة اليدوية ينزل ٩٠٪',
    'يلقط مخالفة السياسة قبل ما تتصاعد',
  ],
};
